export default __webpack_public_path__ + "static/BrownStd-Light-1493d9e12097ef5824d3938954f6f609.woff";